"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M36.977 26.447l-12.41 8.611a.994.994 0 0 1-1.133 0l-12.41-8.611-7.167 4.972a.5.5 0 0 0 0 .822l19.577 13.582a.994.994 0 0 0 1.133 0L44.143 32.24a.5.5 0 0 0 0-.822z" }),
  React.createElement("path", { d: "M23.434 30.164L3.858 16.581a.5.5 0 0 1 0-.822L23.434 2.177a.993.993 0 0 1 1.132 0L44.142 15.76a.5.5 0 0 1 0 .822L24.566 30.164a.993.993 0 0 1-1.132 0z" })
);

